import React from 'react';
import { Dialog, DialogContent } from './dialog';
import { cn } from '../../lib/utils';

// Custom editors keep their own header/footer markup while sharing the modal
// focus, scroll-lock, safe-area and portal behavior. No implicit dismiss button.
export default function ModalSurface({ children, label, onClose, size = 'lg', className }) {
  return <Dialog open onOpenChange={open => { if (!open) onClose?.(); }}>
    <DialogContent portal showCloseButton={false} size={size} aria-label={label}
      className={cn('block p-0 sm:p-0', className)}>
      {children}
    </DialogContent>
  </Dialog>;
}
